import ShopSupplierModelBase from '../_generated/modelBases/shop-supplier-model-base';

export default class ShopSupplierModel extends ShopSupplierModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
